import { BlueprintInstanceType } from '../shared.enums';
import { notificationData } from './notification.data';
import { NotificationType } from './enums';
import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';
import { NotificationData, NotificationDataIn } from './types';

export class Notification extends KitchenDesignBase<NotificationDataIn> {
	#refId: string;
	#itemRefId: string;
	#validationCode: string;
	#description: string;
	#createDate: string;
	#createdBy: string;
	#acceptedDate?: string;
	#acceptedBy?: string;
	#type: NotificationType;

	constructor (options: KitchenDesignOptions<NotificationDataIn> = {}) {
		super(BlueprintInstanceType.Notification, options);

		const { dataIn = null } = options;
		const data = notificationData(this.context, dataIn);

		this._id = data.id;
		this.#refId = data.refId;
		this.#itemRefId = data.itemRefId;
		this.#validationCode = data.validationCode;
		this.#description = data.description;
		this.#createDate = data.createDate;
		this.#createdBy = data.createdBy;
		this.#acceptedDate = data.acceptedDate;
		this.#acceptedBy = data.acceptedBy;
		this.#type = data.type;

		this.setInitialized();
	}

	get refId (): string { return this.#refId }
	get itemRefId (): string { return this.#itemRefId }
	get validationCode (): string { return this.#validationCode }
	get description (): string { return this.#description }
	get createDate (): string { return this.#createDate }
	get createdBy (): string { return this.#createdBy }
	get acceptedDate (): string { return this.#acceptedDate }
	get acceptedBy (): string { return this.#acceptedBy }
	get type (): NotificationType { return this.#type }

	public acceptNotification (): void {
		// can only be accepted once
		if (this.#acceptedBy === null) {
			this.#acceptedBy = this.context.userEmail;
			this.#acceptedDate = Date.now().toString();
		}
	}

	// serialize
	public serialize (): NotificationData {
		return {
			id: this._id,
			refId: this.#refId,
			itemRefId: this.#itemRefId,
			validationCode: this.#validationCode,
			description: this.#description,
			createDate: this.#createDate,
			createdBy: this.#createdBy,
			acceptedDate: this.#acceptedDate,
			acceptedBy: this.#acceptedBy,
			type: this.#type
		};
	}
}
